import React, { useState, useEffect } from 'react';
import '../EvaluacionRiesgoModal.css';

const EvaluacionRiesgoModal3 = ({ siguiente, anterior, onClose, formData, setFormData }) => {
  const [extensionGeografica, setExtensionGeografica] = useState(null);
  const [caracteristicasEvento, setCaracteristicasEvento] = useState(null);

  useEffect(() => {
    setExtensionGeografica(formData.extensionGeografica);
    setCaracteristicasEvento(formData.caracteristicasEvento);
  }, [formData]);

  const extensionOptions = [
    {
      text:
    `- Población afectada por una situación de desastre natural con compromiso de la capacidad de respuesta.\n- No se cuenta con capacidad para el ingreso al área.`,
    value: 50,
    },
    {
      text:
    `- Se puede acceder al área afectada en menos de 6 horas.\n- Población indígena y/o grupos poblacionales especiales.`,
    value: 1,
    },
    {
      text:
    `- Se puede acceder al área afectada entre 6 y 48 horas.\n- Son grupos poblacionales especiales en zonas no municipalizadas.`,
    value: 5,
    },
    {
      text:
    `- Se puede acceder al área afectada entre 48 horas y 72 horas.\n- Población afectada por calamidad natural o antrópica, sin afectación a la capacidad de respuesta.`,
      value: 15,
    },
  ];

  const caracteristicaOptions = [
    {
      text:
    `El nivel departamental no cuenta con capacidad de respuesta:\n\n- Recursos limitados del nivel local y departamental`,
    value: 15,
    },
    {
      text:
    `Capacidad de respuesta a nivel central:\n\n- Planes de preparación y respuesta a emergencias.\n- Disponibilidad de un ERI nacional con capacidad de despliegue.`,
    value: 50,
    },
    {
      text:
    `El municipio o zona no municipalizada no cuenta con capacidad de respuesta, pero el Departamento sí:\n\n- Planes de preparación y respuesta a emergencias.\n- Disponibilidad de un ERI departamental y profesionales con entrenamiento en investigación de campo.\n- Cuentan con insumos suficientes`,
    value: 5,
    },
    {
      text:
    `El municipio cuenta con capacidad de respuesta:\n\n- Planes de preparación y respuesta a emergencias.\n- Disponibilidad de ERI municipal y profesionales con entrenamiento en investigación de campo.\n- Cuentan con insumos suficientes.`,
      value: 1,
    },
  ];

  const handleNext = () => {
    setFormData({
      ...formData,
      extensionGeografica,
      caracteristicasEvento
    });
    siguiente();
  };

  const handleBack = () => {
    setFormData({
      ...formData,
      extensionGeografica,
      caracteristicasEvento
    });
    anterior();
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h3 className="text-center mb-3">EVALUACIÓN DEL RIESGO</h3>
        <div className="row">
          {/* Extensión Geográfica */}
          <div className="col-md-6">
            <h6>Acceso geográfico</h6>
            <div className="cuadros-container">
              {extensionOptions.map((item, index) => (
  <div
    key={index}
    className={`opcion-cuadro ${extensionGeografica === item.value ? 'seleccionado' : ''}`}
    onClick={() => setExtensionGeografica(item.value)}
  >
    <input
      type="radio"
      name="extensionGeografica"
      checked={extensionGeografica === item.value}
      readOnly
      className="mb-2"
    />
    <pre className="opcion-texto">{item.text}</pre>
  </div>
))}
            </div>
          </div>

          {/* Características del evento */}
          <div className="col-md-6">
            <h6>Investigación epidemiológica de campo</h6>
            <div className="cuadros-container">
              {caracteristicaOptions.map((item, index) => (
  <div
    key={index}
    className={`opcion-cuadro ${caracteristicasEvento === item.value ? 'seleccionado' : ''}`}
    onClick={() => setCaracteristicasEvento(item.value)}
  >
    <input
      type="radio"
      name="caracteristicasEvento"
      checked={caracteristicasEvento === item.value}
      readOnly
      className="mb-2"
    />
    <pre className="opcion-texto">{item.text}</pre>
  </div>
))}
            </div>
          </div>
        </div>

        <div className="text-center mt-4">
          <button className="btn btn-outline-primary me-2" onClick={handleBack}>Anterior</button>
          <button className="btn btn-secondary me-2" onClick={onClose}>Cerrar</button>
          <button
  className="btn btn-primary"
  onClick={handleNext}
  disabled={extensionGeografica === null || caracteristicasEvento === null}
>
  Siguiente
</button>
        </div>
      </div>
    </div>
  );
};

export default EvaluacionRiesgoModal3;
